
import { Component, Vue } from 'vue-property-decorator'
import { EmployeeClient } from '@/api'
import EmployeeEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'

@Component({
  name: 'EmployeeList',
  components: {
    EmployeeEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new EmployeeClient()
    this.listQuery = {
      filter: {
        where: { name: { like: '' }, isDeleted: false },
        fields: {
          id: true,
          _id: true,
          stationId: true,
          name: true,
          sex: true,
          nation: true,
          birthday: true,
          home_address: true,
          id_card_number: true,
          mobile_phone_number: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt'],
        include: [{ relation: 'station' }]
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: any) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: any) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
